import styled from "styled-components";
import { sidebarWidth } from "~/components/layout/Sidebar.style";
import { getColor, responsive } from "~/helpers/style";
import { UIProps } from "~/types/style";

export const LoaderContainer = styled.div<
  { fullWidth?: boolean; isFixed?: boolean; color?: string } & UIProps
>`
  display: flex;
  align-items: center;
  justify-content: center;
  height: auto;
  width: auto;
  position: ${({ isFixed }) => (isFixed ? "fixed" : "")};
  top: ${({ isFixed }) => (isFixed ? "50%" : "")};
  left: ${({ isFixed }) => (isFixed ? "50%" : "")};
  transform: ${({ isFixed }) => (isFixed ? "translate(-50%, -50%)" : "")};
  z-index: 1;

  ${responsive("tablet")} {
    transform: ${({ fullWidth, isFixed }) =>
      !isFixed
        ? ""
        : fullWidth
          ? "translate(-50%, -50%)"
          : `translate(calc(-50% + ${sidebarWidth / 2}px), -50%)`};
  }

  circle {
    stroke: ${(props) => getColor(props.color || "primary")};
  }
`;
